import { Module } from "vuex";
import RootState from "./root-state";
import EstimatePaymentMethodApi from "@/api/gateways/estimate-payment-method-api";
import { ServiceEstimatePaymentMethodRow } from "@/api/project/estimate-payment-method-api";

export default {
  namespaced: true,
  state: {
    rows: [] as ServiceEstimatePaymentMethodRow[]
  },
  getters: {
    all: (state): ServiceEstimatePaymentMethodRow[] => state.rows
  },
  mutations: {
    init(state, rows: ServiceEstimatePaymentMethodRow[]) {
      state.rows = rows;
    }
  },
  actions: {
    async init({ commit, rootGetters }) {
      const gw = new EstimatePaymentMethodApi(rootGetters.api);
      commit("init", await gw.all());
    },
    async sort(
      { commit, dispatch, rootGetters },
      keys: ServiceEstimatePaymentMethodRow[]
    ) {
      commit("init", keys);
      const gw = new EstimatePaymentMethodApi(rootGetters.api);
      await gw.sort(keys.map(t => Number(t.id)));
      await dispatch("init");
    },
    async remove({ dispatch, rootGetters }, id: number) {
      const gw = new EstimatePaymentMethodApi(rootGetters.api);
      await gw.remove(id);
      await dispatch("init");
    }
  }
} as Module<EstimatePaymentMethodState, RootState>;

interface EstimatePaymentMethodState {
  rows: ServiceEstimatePaymentMethodRow[];
}
